// extracted by mini-css-extract-plugin
export default {"iconsContainer":"ContactIcons_iconsContainer__B0S+3","linkedinIcon":"ContactIcons_linkedinIcon__m4CIi","githubIcon":"ContactIcons_githubIcon__NlK+r"};